export const tokenName = 'tokenCincel';
export const tokenV3Name = 'tokenV3Cincel';
export const expirationName = 'expirationCincel';
export const userName = 'userCincel';
export const cincelSession = 'cincelSession-data';
